import React from 'react';

interface OptimizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  webpSrc?: string;
  fallbackSrc?: string;
  alt: string;
  className?: string;
  loading?: 'eager' | 'lazy';
  width?: number;
  height?: number;
}

/**
 * OptimizedImage component that serves WebP images with fallbacks
 * Automatically handles WebP support detection and provides fallbacks
 */
const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  webpSrc,
  fallbackSrc,
  alt,
  className = '',
  loading = 'lazy',
  width,
  height,
  ...props
}) => {
  // If webpSrc is not provided, try to construct it from src
  const webpSource = webpSrc || (src.includes('.webp') ? src : src.replace(/\.(jpg|jpeg|png)$/i, '.webp'));
  const fallback = fallbackSrc || src;

  return (
    <picture className={className}>
      {/* WebP source for modern browsers */}
      <source srcSet={webpSource} type="image/webp" />
      
      {/* Fallback for browsers that don't support WebP */}
      <img
        src={fallback}
        alt={alt}
        loading={loading}
        width={width}
        height={height}
        className="w-full h-auto"
        {...props}
      />
    </picture>
  );
};

export default OptimizedImage;